import { TagChip } from '@cognite/cogs.js-v10';
import styled from 'styled-components';

export const ClickableTagChip = styled(TagChip)`
  cursor: pointer;
`;
